import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import { AbstractControl,FormBuilder,FormGroup,ReactiveFormsModule, ValidationErrors,Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {PocService} from "../../../../services/poc-service/poc.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {ShortClientDto} from "../../../_models/client.dtos";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { EmplacementService } from '../../../../services/emplacement-service/emplacement.service';
import { emplacementDTO } from '../../../_models/emplacementDto';

@Component({
    standalone: true,
    providers: [HandleErrorsService, ApiService, Endpoints, DialogService, PocService, ClientsService],
    imports: [
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, DatePipe, MatCheckbox
    ],
  selector: 'app-emplacement',
  templateUrl: './emplacement.component.html',
  styleUrl: './emplacement.component.scss'
})

export class EmplacementComponent {
    @Input() clientsPoc: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    editForm: FormGroup;
    form: FormGroup;
    clientList: ShortClientDto[]
    dataSource = new MatTableDataSource<emplacementDTO>();
    searchValue: string = ''
    empl?: emplacementDTO
    loadingTable: boolean = true;

displayedColumns: string[] = [
  'nom',          
  'description',                
];
    columns: string[] = [...this.displayedColumns];

    constructor(
        private cookieService: CookieService,
        private handleErrorsService: HandleErrorsService,
        private emplacementService: EmplacementService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
    }

    ngOnInit(): void {
        this.fetchEmplacementList()
        this.initializeEditForm();
        this.initializeCreateForm()
        this.getColsCookie()
    }

fetchEmplacementList(): void {
  this.emplacementService.getAllEmplacements().subscribe({
    next: (emplacement) => {
      console.log('✅ Emplacements actifs reçus:', emplacement);
      this.dataSource.data = emplacement;
    },
    error: (err) => {
      console.error("❌ Erreur :", err);
    }
  });
}

    

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    private initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
    }

    initializeEditForm() {
        this.editForm = this.fb.group({
            id: ['', Validators.required],
            nom: ['', Validators.required],
            description: ['', Validators.required],

        });
    }

    initializeCreateForm() {
        this.form = this.fb.group({
            nom: ['', Validators.required],
            description: ['', Validators.required],

        });
    }
    openEditModal(element: emplacementDTO) {
        this.editForm.patchValue(element);
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    }

    saveEmplacement(): void {
        if (this.form.valid) {
            this.emplacementService.createEmplacement(this.form.value).subscribe({
                next: response => {
                        this.form.reset();
                        this.fetchEmplacementList();
                        this.modalService.dismissAll();
                        this.dialogService.openSuccessDialog("Emplacement ajouté avec succès.");
                },
                error: err => {
                    console.error("❌ Erreur API :", err);
                }
            });
        } else {
            this.dialogService.openInvalidFormDialog();
        }
    } 

    updateEmplacement() {
        if (this.editForm.valid) {
            const formData = this.editForm.value;

            this.emplacementService.updateEmplacement(formData.id,formData).subscribe({
                next: response => {
                        this.updateTableRow(response)
                        this.modalService.dismissAll()
                        this.dialogService.openSuccessDialog("Emplacement modifié avec succès.")
                },
                error: err => this.handleErrorsService.catchError(err),
                complete: () => this.initializePaginatorAndSort()
            })
        } else {
            this.dialogService.openInvalidFormDialog()
        }
    }

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.confirm('Etes-vous sûr de vouloir supprimer cet emplacement?')
            .then((result: any) => {
                if (result) {
                    this.deleteEmplacement(element.id);
                }
            });
    }
    deleteEmplacement(id: number) {
        this.emplacementService.deleteEmplacement(id).subscribe({
            next: response => {
                this.removeTableRow(id);
                this.dialogService.openSuccessDialog('Emplacement supprimé avec succès')
            
            },
            error : err => this.handleErrorsService.catchError(err),
            complete: () => this.initializePaginatorAndSort()
        });
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.dataSource.filter = this.searchValue
    }

    openViewModel(element: emplacementDTO) {
        this.empl = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});

    }
    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then(
            () => {
                this.form.reset()
            },
            () => {
                this.form.reset()
            }
        );
    }
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`emplacement_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
    private getColsCookie() {
        const emplacementCols = this.cookieService.get(`emplacement_${this.user_name}`); // Get the cookie value

        if (emplacementCols) {
            this.displayedColumns = JSON.parse(emplacementCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', emplacementCols);
        }
    }
}


